import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { useConsultInvoiceHub } from '@/core/domain/invoiceTransmissionHub/Invoice/Invoice.hooks';
import { useConsultInvoiceNfs } from '@/core/domain/nfs/NfseController/NfseController.hooks';
import { Button } from 'antd';

interface Props {
  type: InvoiceType;
}

const ConsultInternalButton = ({ type }: Props) => {
  const { invoiceId } = useInvoiceFormContext();

  const consultInvoiceHub = useConsultInvoiceHub();
  const consultInvoiceNfs = useConsultInvoiceNfs();

  const consultInvoice = async () => {
    try {
      type === InvoiceType.NFS
        ? await consultInvoiceNfs.mutateAsync(Number(invoiceId))
        : await consultInvoiceHub.mutateAsync({
            invoiceId: Number(invoiceId),
            type,
          });
    } catch {}
  };

  const loading = consultInvoiceHub.isLoading || consultInvoiceNfs.isLoading;

  return (
    <>
      {loading && (
        <ModalLoadingOverlay
          messages={['Consultando nota...', 'Validando dados da nota...']}
        />
      )}

      <Button
        loading={consultInvoiceHub.isLoading}
        block
        type="primary"
        onClick={consultInvoice}
      >
        Consultar Situação
      </Button>
    </>
  );
};

export default ConsultInternalButton;
